<div class="px-4 pb-4">
  <div
    class="px-4 py-2 w-full flex justify-between gap-4 bg-white border border-neutral-300 border-t-0 rounded-b-sm"
    [class.border-red-400]="!isExternal && isEscalated"
  >
    <div class="form-layout form-grid-row w-1/3">
      <label>Name:</label>
      <div class="full-name readonly">
        {{ memberSearch.memberDTO.firstName }}
        {{ memberSearch.memberDTO.lastName }}
      </div>
      <label>Member ID:</label>
      <div class="member-id readonly">
        {{
        memberSearch.memberDTO.displayMemberId !== null
        ? memberSearch.memberDTO.displayMemberId
        : memberSearch.memberDTO.subscriberNumber
        }}
      </div>

      @if (shouldShowGroupId()) {
        <label>Group ID:</label>
        <div class="form-value readonly">{{ groupId }}</div>
      }

      <label>Date of Birth:</label>
      <div class="readonly">
        <span
          tooltipPosition="right"
          class="date-of-birth"
          [pTooltip]="getAge(memberSearch.memberDTO.dateOfBirth)">{{ memberSearch.memberDTO.dateOfBirth | date: 'MM/dd/yyyy' }}
        </span>
      </div>
      @if (!isExternal) {
        <label>Gender:</label>
        <div class="readonly">
          @if (memberSearch.memberDTO.gender === 'M' || memberSearch.memberDTO.gender === 'Male') {
            <span
              class="gender"
              >
              Male
            </span>
          }
          @if (memberSearch.memberDTO.gender === 'F'|| memberSearch.memberDTO.gender === 'Female') {
            <span
              class="gender"
              >
              Female
            </span>
          }
        </div>
      }
      @if (!isExternal) {
        <label>Language:</label>
        <div class="readonly">{{ memberSearch?.memberDTO?.memberLanguage || '--' }}</div>
      }
    </div>
    <div class="form-layout form-grid-row w-1/3">
      <label>Health Plan:</label>
      <div class="readonly">
        <span class="health-plan  {{ healthPlanName | menuColorClass }}">
          {{ healthPlanName }}
        </span>
      </div>
      @if (!isExternal) {
        @if (memberBenefit?.isTransitionPeriod) {
          <label class="highlighted flagged-plan">Health/Benefit Plan:</label>
          <div class="highlighted flagged-plan readonly">
            <span class="break-all">{{ memberBenefit?.benefitPlan }}</span>
            <i
              pTooltip="Transition period: {{transformBenefitPlanEffectiveDate}}"
              tooltipPosition="bottom"
              aria-hidden="true"
              class="pi pi-exclamation-triangle ml-4"></i>
          </div>
        } @else {
          <label>Health/Benefit Plan:</label>
          <div class="readonly">
            <div class="flex flex-wrap gap-1">
              @if (!isCommercialLOB) {
                <span class="break-all">
                  {{ memberBenefit?.benefitPlan }}
                </span>
              }
              @if (isCommercialLOB) {
                <button
                  pButton
                  class="p-button-link p-0 text-left eoc"
                  [label]="memberBenefit?.benefitPlan"
                  [pTooltip]="getTooltipMessage"
                  tooltipPosition="bottom"
                  (click)="downloadDocument()"
                ></button>
              }
              @if (memberBenefit?.benefitPlanClassificationType === DualsPlanType.FIDE) {
                <duals-indicator 
                  [planType]="memberBenefit?.benefitPlanClassificationType"
                  [mcoName]="memberBenefit?.mcoName"
                  [mcoState]="memberBenefit?.mcoState" />
              } @else {
                <span
                  class="mark"
                  [class]="lineOfBusiness?.class"
                >{{ lineOfBusiness?.text }}</span>
              }
            </div>
            @if (showMaStateMandateMessage()) {
              <div class="ohio-condition mt-1">
                <i class="pi pi-exclamation-triangle mr-1"></i>
                <span>Follow the WA State mandate-specific process</span>
              </div>
            }
            @if (showInMandateApplies() && showWaGroupIdentifier) {
              <div class="cova-identifier mt-1">
                <i class="pi pi-exclamation-triangle mr-1"></i>
                <span>IN State Mandate Applies</span>
              </div>
            }
            @if (showCovaIdentifier || isOHIO) {
              <div
                [class] = "{
                'cova-identifier mt-1' : showCovaIdentifier,
                'ohio-condition': isOHIO
                }">
                <i class="pi pi-exclamation-triangle mr-1"></i>
                <span>Follow the State of OH/COVA-specific process</span>
              </div>
            }
          </div>
        }
      }

      @if ((memberBenefit?.programState === 'IN' || (memberBenefit?.programState === 'TX' && healthPlanName === 'Wellpoint')) && utilizationReviewNumber && isCommercialLOB) {
        <label>UR Number:</label>
        <div class="readonly">{{ utilizationReviewNumber }}</div>
      }

      @if (!isExternal) {
        <label>Eligibility:</label>
        <div class="flex flex-wrap gap-1 readonly">
          @if (!(memberSearch.memberDTO.delegationStatus === 'Non-Delegated')) {
            <div class="flex flex-wrap gap-1">
              <span>
                {{ memberSearch.memberDTO.effectiveBeginDate | date: 'MM/dd/yyyy' }}
                -
                {{ memberSearch.memberDTO.effectiveEndDate | date: 'MM/dd/yyyy' }}
              </span>
              @if (checkStatusCancelled()) {
                <span class="mark cancelled">
                  Cancelled
                </span>
              } @else {
                @if (!memberSearch.memberDTO.isEligible) {
                  <span class="mark-inactive">
                    inactive
                  </span>
                } @else {
                  <span class="mark active">Active</span>
                }
              }
              @if (isCommercialLOB && showFundingIndicator()) {
                <span>
                  <i class="pi pi-info-circle ml-2" tooltipPosition="bottom" [pTooltip]="getFundingTypeTooltipText()"></i>
                </span>
              }
            </div>
          } @else {
            <span>Non-Covered Prospect Member</span>
          }
        </div>
      }
      @if (!isExternal) {
        <label>Health Plan Specialty Program:</label>
        <div class="readonly">
          {{ specialtyProgram }}
        </div>
      }
      <ng-container *accessView="['PrimaryCarePhysicianHistory.Read']">
        @if (isCommercialLOB && primaryCarePhysician?.primaryCarePhysicianHistoryId) {
          <label>NEHP:</label>
          <div class="flex flex-wrap gap-1 readonly">
            <span>
              {{ primaryCarePhysician.physicianEffectiveDate | date: 'MM/dd/yyyy' }}
              -
              {{ primaryCarePhysician.physicianEndDate | date: 'MM/dd/yyyy' }}
            </span>
            <span class="mark" [class]="primaryCarePhysician.status === 'Active' ? 'active' : 'inactive'">
              {{ primaryCarePhysician.status }}
            </span>
          </div>
        }
      </ng-container>
      @if (!isExternal) {
        <label>WCC Assigned Liaison:</label>
        <div class="readonly">
          {{ memberSearch.memberDTO.wccAssignedLiaison }}
        </div>
      }
    </div>
    <div class="form-layout form-grid-row w-1/3">
      <label>Member State:</label>
      <div class="readonly">
        {{ residentialAddress?.state || memberSearch.memberDTO.state }}
        @if (!isExternal) {
          <mnc-member-disaster-declaration-badge
            lazyComponent
            [subscriberNumber]="memberSearch.memberDTO.subscriberNumber"
            [tenantId]="tenantId"
            [lineOfBusiness]="lineOfBusiness?.text"
          ></mnc-member-disaster-declaration-badge>
        }
      </div>
      @if (!isExternal) {
        <label>C3:</label>
        <div class="readonly">
          {{ memberSearch.memberDTO.c3 ? 'Yes' : 'No' }}
        </div>
      }
      @if (!isExternal) {
        <label [class]="{ 'escalated-case-member': isEscalated }">Assigned Liaison:</label>
        <div class="readonly" [class]="{ 'escalated-case-member': isEscalated }">
          {{ memberSearch.memberDTO.assignedLiaison ? 'Yes' : 'No' }}
        </div>
      }
      @if (memberSearch.memberDTO.assignedLiaison && !isExternal) {
        <label [class]="{ 'escalated-case-member': isEscalated }">Liaison Name:</label>
        <div class="readonly" [class]="{ 'escalated-case-member': isEscalated }">
          {{ memberSearch.memberDTO.assignedLiaisonName }}
        </div>
      }
      @if (!isExternal) {
        <label>POA/AOR Name:</label>
        <div class="readonly">
          @if (memberSearch.memberDTO.aorName) {
            <span>
              {{ memberSearch.memberDTO.aorName }}
            </span>
          }
        </div>
      }
      @if (!isExternal) {
        <label>POA/AOR Date Signed:</label>
        <div class="readonly">
          {{ memberSearch.memberDTO.aorDateSigned | date: 'MM/dd/yyyy' }}
        </div>
      }
    </div>
  </div>
</div>
